import React, { Children, useEffect, useState } from 'react'
import classes from '../styles/Modal.module.scss'
import { useDispatch,useSelector } from 'react-redux'
import { Navigate } from 'react-router-dom'

import {closeModal,selectModalRedirect,selectModalTitle} from '../redux/features/modalSlice'

const Modal = ({children}) => {

    const [status, setStatus] = useState("")
    const dispatch= useDispatch()
    const modalTitle =useSelector(selectModalTitle)
    let redirectOnModalOK=useSelector(selectModalRedirect)

    const navigateOnRedirectTrue= ()=>{
        if (redirectOnModalOK){
            console.log("call in redirect")
            Navigate({ to: '/' })

        }     
    }

    useEffect(() => {
        console.log("called before redirect")
        //navigateOnRedirectTrue()   
       
    }, [])

    

    return (
        <div className={classes.container}>
            <div className={classes.wrapper}>
                <div className={classes.header}>{modalTitle}<div onClick={()=> dispatch(closeModal())}>X</div></div>
                <div className={classes.body+" "+classes.message} data-test="modal-message">{children}</div> 
                <div className={classes.footer}>
                    <button className={classes.btn} id="exit" onClick={()=> dispatch(closeModal())}>OK</button>
                </div>
            </div>
        </div>
    )

}

export default Modal